import Sortable from 'sortablejs';
import { get, post, put, patch, destroy } from '@rails/request.js'

document.addEventListener('DOMContentLoaded', function(event) {
  const kanbanUls = document.querySelectorAll(".kanban .kanban-col");

  kanbanUls.forEach((ul) => {
    new Sortable(ul, {
      group: ul.dataset.group || 'kanban',
      animation: 300,
      onEnd: async function (event) {
        // var itemEl = event.item;  // dragged HTMLElement
        // event.to;    // target list
        // event.from;  // previous list
        // event.oldIndex;  // element's old index within old parent
        // event.newIndex;  // element's new index within new parent
        // event.oldDraggableIndex; // element's old index within old parent, only counting draggable elements
        // event.newDraggableIndex; // element's new index within new parent, only counting draggable elements
        // event.clone // the clone element
        // event.pullMode;  // when item is in another sortable: `"clone"` if cloning, `true` if moving

        // console.log('Item: ' + event.item.dataset.issueId);
        // console.log('Item moved from index ' + event.oldIndex + ' to ' + event.newIndex);
        // console.log('Item moved from list ' + event.from.dataset.status + ' to ' + event.to.dataset.status);

        const response = await patch('/issues/' + event.item.dataset.issueId + '/update_from_kanban', { body: JSON.stringify({ issue: { status: event.to.dataset.status }}) })
        if (response.ok) {
          // const body = await response.json
          // console.log('Request successful: ' + body.message);
        } else {
          // Revert the item to its original position if request fails
          if (event.from && event.item && typeof event.oldIndex === 'number') {
            const children = Array.from(event.from.children);
            if (children.length > event.oldIndex) {
              event.from.insertBefore(event.item, children[event.oldIndex]);
            } else {
              event.from.appendChild(event.item);
            }
          }
        }
      },
    });
  });

});

